import { GET_WEEK_REPORT } from "./activityReportConstants";

export function report(state = [], action) {
    switch (action.type) {
        case GET_WEEK_REPORT:
            if (!action.payload) {
                return null;
            }
            return action.payload;
        default:
            return state;
    }
}
